import { ReactNode } from 'react';

import { User } from 'entities';

import { Row } from 'components/Blocks';
import { UserAvatar } from 'components/UserAvatar';

interface UserLabelProps {
  children?: never;
  user: User;
}

export function UserLabel({ user }: UserLabelProps): JSX.Element {
  return (
    <Row gap="1.5">
      <UserAvatar size={24} className="text-xs" user={user} />

      <span>{user.name}</span>
    </Row>
  );
}

export const getUserLabel = (user: User): ReactNode => <UserLabel user={user} />;
